import { Option } from 'shared/components/Select/models/Option';
import { commissionTypeLabel } from 'shared/constants/filters/advanced/commissionTypeLabel';
import { ECommissionType } from 'shared/types/filters/advanced/commissionType';

export const commisionTypeOptions = [
  new Option(ECommissionType.WithoutDeposit, commissionTypeLabel[ECommissionType.WithoutDeposit]),
  new Option(ECommissionType.Exclusive, commissionTypeLabel[ECommissionType.Exclusive]),
];
